const apiBaseUrl = process.env.VUE_APP_API_BASE_URL,
    wsBaseUrl = process.env.VUE_APP_WS_URL

const config  = {
    apiBaseUrl: apiBaseUrl,
    wsBaseUrl: wsBaseUrl,
    wsDebug: process.env.VUE_APP_WS_DEBUG == 'false' ? false : true,
    spotify: {
        clientId: process.env.VUE_APP_SPOTIFY_CLIENT_ID,
        clientSecret: process.env.VUE_APP_SPOTIFY_CLIENT_SECRET
    },
    payment_method: [
        { label: 'Paypal', value: 'paypal' },
        { label: 'Stripe', value: 'stripe-checkout' },
        { label: 'Vipps', value: 'vipps' },
        { label: 'Credit', value: 'credit' }
    ],
    log_type: [
        { label: 'Create Quiz', value: 'user_create_quiz' },
        { label: 'Update Quiz', value: 'user_update_quiz' },
        { label: 'Join Quiz', value: 'user_join_quiz' },
        { label: 'Leave Quiz', value: 'user_leave_quiz' },
        { label: 'Add Credit', value: 'user_added_credit' },
        { label: 'Add Coin', value: 'user_added_coin' },
        { label: 'Remove Credit', value: 'user_removed_credit' },
        { label: 'User Register Normal', value: 'user_register_normal' },
        { label: 'User Register with 3rd party', value: 'user_register_with_3rd_party' },
        { label: 'User Login Normal', value: 'user_login_normal' },
        { label: 'User Login with 3rd party', value: 'user_login_with_3rd_party' },
        { label: 'User Start Quiz', value: 'user_start_quiz' },
        { label: 'User Buy Player with Paypal', value: 'user_buy_player_by_paypal' },
        { label: 'User Buy Player with Stripe', value: 'buy_player_by_stripe' },
        { label: 'User Buy Player with Credit', value: 'user_buy_player_by_credit' },
        { label: 'User Buy Player with Vipps', value: 'buy_player_by_vipps' },
        { label: 'User Send Quiz Approval', value: 'user_send_quiz_approval' },
        { label: 'User Start Subscribe', value: 'user_subscribe' },
        { label: 'User Unsubscribe', value: 'user_unsubscribe' },
        { label: 'User Suspend', value: 'user_suspend' },
        { label: 'Quiz Finish', value: 'quiz_finish' },
        { label: 'Quiz Not Finish', value: 'quiz_not_finish' },
        { label: 'Live Quiz Survey', value: 'live_quiz_survey'},
        { label: 'User Generate AI Questions', value: 'user_generated_ai_question'},
        { label: 'User Generate AI Image', value: 'user_generated_ai_image'},
        { label: 'User Buy AI Questions with Paypal', value: 'buy_ai_questions_by_paypal'},
        { label: 'User Buy AI Questions with Stripe', value: 'buy_ai_questions_by_stripe'},
        { label: 'User Buy AI Questions with Vipps', value: 'buy_ai_questions_by_vipps'},
        { label: 'User Buy Onetime Offer with Paypal', value: 'buy_onetime_offer_by_paypal'},
        { label: 'User Buy Onetime Offer with Stripe', value: 'buy_onetime_offer_by_stripe'},
        { label: 'User Buy Onetime Offer with Vipps', value: 'buy_onetime_offer_by_vipps'},
        { label: 'User Partner', value: 'add_point_partner'}
    ],

    questionTypes: [
        {label: 'Basic Question', code: 'basic'},
        {label: 'Music Question', code: 'music'},
        {label: 'Reveal Image', code: 'reveal_image'},
        {label: 'Scale Image', code: 'scale_image'},
        {label: 'Type Answer', code: 'typing_question'},
        {label: 'Sorting List Answer', code: 'sorting_list'},
        {label: 'Puzzle', code: 'puzzle'},
        {label: 'Video', code: 'video'},
        {label: 'Hot Spot', code: 'hotspot'},
        {label: 'Scramble', code: 'scramble'},
    ],

    supportedLanguages: ['en', 'no', 'se', 'dk', 'fr', 'de', 'es'],

}

export default config
